import React from 'react';
import './inputform.css'


const Inputsec6 = (props) => {
    return ( 
        <fieldset className='container-input-form-sec6'>
            <h2 className='title-input-sec6'>{props.title}</h2>
            <input className='input-sec6-text' placeholder={props.title2}/>
        </fieldset>
     );
}
 
export default Inputsec6;